import { createContext } from 'react';
import { type Locale } from '../i18n';

export interface AuthUser {
  id: string;
  email: string;
  plan: 'starter' | 'founder' | 'scale';
  generations_used: number;
  generations_limit: number;
  period_start: string;
  locale?: Locale;
  role?: 'user' | 'admin';
}

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  error: string | null;
  isAdmin: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, plan?: AuthUser['plan']) => Promise<void>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
  updateLocale: (locale: Locale) => Promise<void>;
  upgradePlan: (plan: AuthUser['plan']) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
